import { planningAPI } from "../../axios";

export const actions = {

    //DepartmentPlanningApiResource
    GetDepartmentPlanningApiResources(context, data){
        return planningAPI.get(`DepartmentPlanningApiResource/${data.apiId}/${data.budgetId}`);
    },
    GetDepartmentPlanningApiResourcesByApi(context, data){
        return planningAPI.get(`DepartmentPlanningApiResource/All/${data}`);
    },
    GetSingleDepartmentPlanningApiResource(context, data){
        return planningAPI.get(`DepartmentPlanningApiResource/${data}`);
    },
    UpdateDepartmentPlanningApiResource(context, data){
        return planningAPI.put(`DepartmentPlanningApiResource/Update/${data.id}`, data);
    },
    DeleteDepartmentPlanningApiResource(context, data){
        return planningAPI.delete(`DepartmentPlanningApiResource/Delete/${data}`);
    },
    CreateDepartmentPlanningApiResource(context, data){
        return planningAPI.post(`DepartmentPlanningApiResource/Add`, data);
    },
    GetAllDepartmentPlanningApiResources(context, data){
        return planningAPI.get(`DepartmentPlanningApiResource/FinanceTemplateBudgetItem/${data}`);
    },
    GetAllBudgetResources(context, data){
        return planningAPI.get(`DepartmentPlanningApiResource/BudgetItem/All/${data}`);
    },
    MovePlanningApiResource(context, data){
        return planningAPI.put(`DepartmentPlanningApiResource/Move/${data.id}/${data.departmentPlanningApiId}`);
    }
}